let currentAnimationElement;

function smoothScrollAnchor(element) {
    if (currentAnimationElement) {
        currentAnimationElement.stop();
        currentAnimationElement = null;
    }

    if (location.pathname.replace(/^\//, '') === element.pathname.replace(/^\//, '') && location.hostname === element.hostname) {
        let target = $(element.hash);
        target = target.length ? target : $('[name=' + element.hash.slice(1) + ']');
        if (target.length) {
            currentAnimationElement = $('html,body');

            $.when(currentAnimationElement.animate({
                scrollTop: target.offset().top,
            }, 1000))
                .then(function () {
                    currentAnimationElement = null;
                    $(target.selector).focus();
                    history.pushState('', '', target.selector);
                });

            return false;
        }
    }
}

/**
 * @param selector (optional) - A custom selector for elements to smooth scroll.
 * Defaults to hash tag anchors
 */
export function bindSmoothScroll(selector) {
    if (!selector) {
        selector = 'a[href*="#"]:not([href="#"])';
    }
    $('body').on('click', selector, function () {
        return smoothScrollAnchor(this);
    });
}
